import { styled as muiStyle } from '@mui/material/styles';
import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps
} from '@mui/material';

export const StyledCircularProgress = muiStyle(MuiCircularProgress)<MuiCircularProgressProps>(
  ({ theme, color }) => ({
    ...(!color && {
      color: theme.palette.grayscaleSecondary[200]
    }),
    ...(color === 'inherit' && {
      color: theme.palette.grayscaleSecondary[200]
    })
  })
);
